module.exports = __webpack_public_path__ + "loading.gif?abb12e1564c4df178041691b656aa705";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = 397
// module chunks = 0